<template>
    <div>
        <bc-circle-loader v-if="loading == true"></bc-circle-loader>
        <v-container v-else fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ bill.bill_id ? $t("lang.edit_vendor_invoice") : $t("lang.add_vendor_invoice") }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="bill.bill_id && bill.bill_id > 0" @invoke-method="dbGetVendorInvoice(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="bill.bill_id && bill.bill_id > 0 && bill.status_id != 90">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="setupBillPaymentDialog(null)" v-if="bill.bill_id && bill.bill_id > 0">
                                    <v-list-tile-title>Record Payment</v-list-tile-title>
                                </v-list-tile>
                                <!--<template v-if="hasPerm('bills.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in bill_status" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != bill.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>-->
                                <template v-if="hasPerm('bills.delete') && bill.bill_payments == null">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_vendor_invoice.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'bills' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-container fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <bc-transaction-links :items="bill.transaction_links" :object_id="bill.bill_id"></bc-transaction-links>
                    <v-flex :class="bill.bill_id != null ? 'lg10 md9 xs12' : 'lg12 md12 xs12'" pb-0 mb-0>
                        <v-card elevation="0">
                            <v-card-text :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                                <div v-if="bill.status" class="ribbon ribbon-top-right" :class="`ribbon-${bill.status_class}`">
                                    <span class="ribbon-span">{{ bill.status }}</span>
                                </div>
                                <div v-else class="ribbon ribbon-top-right ribbon-grey"><span class="ribbon-span">Draft</span></div>

                                <vue-perfect-scrollbar
                                    class="scroll-area"
                                    :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                                >
                                    <v-card-text v-if="bill.bill_payments != null" :class="$bp.smallScreen ? 'pa-0' : null">
                                        <v-card
                                            color="grey lighten-4 mb-2"
                                            elevation="0"
                                            @click="showBillPayments = !showBillPayments"
                                            class="underline-on-hover"
                                            style="cursor: pointer"
                                        >
                                            <v-card-title
                                                ><label style="cursor: pointer">Payments Made ({{ bill.bill_payments.length }})</label></v-card-title
                                            >
                                        </v-card>
                                        <div :class="{ 'slide-up': !showBillPayments, 'slide-down': showBillPayments }">
                                            <v-card v-if="showBillPayments" class="slide-container" elevation="0" style="background: transparent">
                                                <v-data-table
                                                    :headers="bill_payment_headers"
                                                    :items="bill.bill_payments"
                                                    :no-data-text="$t('lang.no_results_matching')"
                                                    hide-actions
                                                >
                                                    <template slot="items" slot-scope="props">
                                                        <tr class="clickable" @mouseup.left="setupBillPaymentDialog(props.item)">
                                                            <td>{{ props.item.payment_id }}</td>
                                                            <td>{{ props.item.bill_id }}</td>
                                                            <td>{{ props.item.company }}</td>
                                                            <td>{{ props.item.payment_date }}</td>
                                                            <td>{{ props.item.amount }}</td>
                                                            <td>{{ props.item.payment_method }}</td>
                                                            <td>
                                                                <v-chip
                                                                    disabled
                                                                    round
                                                                    text-color="white"
                                                                    class="fs-14 text-center"
                                                                    :color="props.item.status_class"
                                                                >
                                                                    <span style="min-width: 60px">{{ props.item.payment_status }}</span>
                                                                </v-chip>
                                                            </td>
                                                            <td>{{ props.item.reference_number }}</td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                                <!-- <bc-pagination :page="page" :params="axiosParams" name="bill_payments"></bc-pagination> -->
                                                <v-divider horizontal></v-divider>
                                            </v-card>
                                        </div>
                                    </v-card-text>

                                    <v-form ref="formVendorInvoice">
                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                            <v-flex xs12 sm6 row-2-fr1>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12>
                                                        <bc-autocomplete
                                                            v-model="bill.company_id"
                                                            v-if="bill.status_id != 90 && bill.bill_details.length <= 0"
                                                            :label="`${$t('lang.company_id')} *`"
                                                            :items="filter_vendor_options"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('bills.company_id')"
                                                            @change="selectCustomer(bill.company_id)"
                                                        ></bc-autocomplete>
                                                        <bc-autocomplete
                                                            v-model="bill.company_id"
                                                            v-else
                                                            :label="`${$t('lang.company_id')} *`"
                                                            :items="filter_vendor_options"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            append-icon="lock"
                                                            v-readonly-click
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <div class="customer-address" v-if="bill.billing_address_id != null" style="padding: 12px">
                                                            <h3>
                                                                {{ $t("lang.billing_address_id") }}
                                                                <v-btn
                                                                    v-if="bill.status_id != 90"
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('bill_address')"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div>{{ bill.bill_address1 }}</div>
                                                                <div v-if="bill.bill_address2 != ''">
                                                                    {{ bill.bill_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ bill.bill_city }}, {{ bill.bill_state }},
                                                                    {{ bill.bill_zip_code }}
                                                                </div>
                                                                <div>{{ bill.bill_country_iso_3 }}</div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <!-- <div class="customer-address" v-if="bill.shipping_address_id != null" style="padding: 12px">
                                                            <h3>
                                                                {{ $t("lang.shipping_address_id") }}
                                                                <v-btn color="secondary" icon small @mouseup.left="changeAddress('ship_address')">
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div>{{ bill.ship_address1 }}</div>
                                                                <div v-if="bill.ship_address2 != ''">
                                                                    {{ bill.ship_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ bill.ship_city }}, {{ bill.ship_state }},
                                                                    {{ bill.ship_zip_code }}
                                                                </div>
                                                                <div>{{ bill.ship_country_iso_3 }}</div>
                                                            </div>
                                                        </div> -->
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm6>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-if="bill.bill_id"
                                                        v-model="bill.bill_id"
                                                        :label="$t('lang.bill_number')"
                                                        :counter="showCounter(bill.bill_id, 'bills.bill_id')"
                                                        :rules="ifValid('bills.bill_id')"
                                                        v-readonly-click
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-model="bill.invoice_date"
                                                            :label="$t('lang.bill_date')"
                                                            :rules="ifValid('bills.invoice_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-model="bill.due_date"
                                                            :label="`${$t('lang.due_date')} *`"
                                                            :rules="ifValid('bills.due_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="bill.payment_term_id"
                                                            :label="`${$t('lang.payment_term')} *`"
                                                            :items="filter_payment_terms"
                                                            item-value="payment_term_id"
                                                            item-text="description"
                                                            :rules="ifValid('bills.payment_term_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="bill.invoice_number"
                                                            :label="$t('lang.vendor_invoice_number')"
                                                            :counter="showCounter(bill.invoice_number, 'bills.invoice_number')"
                                                            :rules="ifValid('bills.invoice_number')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="bill.currency_id"
                                                            :label="$t('lang.document_currency')"
                                                            :items="filter_currencies"
                                                            item-value="currency_id"
                                                            item-text="name"
                                                            :rules="ifValid('bills.currency_id')"
                                                            @change="setExchangeRate(bill.currency_id)"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="bill.exchange_rate"
                                                            :label="$t('lang.exchange_rate')"
                                                            :counter="showCounter(bill.exchange_rate, 'bills.exchange_rate')"
                                                            :rules="ifValid('bills.exchange_rate')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-flex xs12 v-if="current_user.login_type_id == '1'">
                                                    <bc-autocomplete
                                                        v-model="bill.project_id"
                                                        :label="`${$t('lang.project')}`"
                                                        :items="projects"
                                                        item-value="project_id"
                                                        item-text="project_name"
                                                        :rules="ifValid('bills.project_id')"
                                                    ></bc-autocomplete>
                                                </v-flex>
                                            </v-flex>
                                        </v-layout>

                                        <div>
                                            <v-data-table
                                                :headers="headers"
                                                :items="bill.bill_details != null ? bill.bill_details : []"
                                                item-key="bill_detail_id"
                                                :no-data-text="$t('lang.no_results_matching')"
                                                hide-actions
                                                class="a-top"
                                            >
                                                <template slot="items" slot-scope="props">
                                                    <tr>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-model="props.item.map_id"
                                                                :items="filter_fe_part_options_by_vendor(props.item)"
                                                                item-value="vendor_map_id"
                                                                item-text="vendor_sku"
                                                                @change="handleChangePart(props.index, props.item)"
                                                                :rules="ifValid('bills.bill_details.map_id')"
                                                            ></bc-autocomplete>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.name"
                                                                :placeholder="$t('lang.name')"
                                                                v-readonly-click
                                                            ></v-text-field>
                                                            <v-text-field
                                                                v-model="props.item.model_number"
                                                                :placeholder="$t('lang.model_number')"
                                                                v-readonly-click
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.quantity"
                                                                :counter="showCounter(props.item.quantity, 'bills.bill_details.quantity')"
                                                                :rules="ifValid('bills.bill_details.quantity')"
                                                                :ref="`${props.index}_quantity`"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-model="props.item.sales_unit"
                                                                :items="filter_sales_units(props.item)"
                                                                item-value="option_id"
                                                                item-text="option"
                                                                :rules="ifValid('bills.bill_details.sales_unit')"
                                                            ></bc-autocomplete>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="convert_currency == true && bill.currency_prefix != null ? bill.currency_prefix : '$'"
                                                                :suffix="convert_currency == true && bill.currency_suffix != null ? bill.currency_suffix : ''"
                                                                v-model="props.item.price"
                                                                :counter="showCounter(props.item.price, 'bills.bill_details.price')"
                                                                :rules="ifValid('bills.bill_details.price')"
                                                            ></v-text-field>
                                                        </td>
                                                        <td style="display: flex">
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-if="props.item.line_discount_type == 'P'"
                                                                v-model="props.item.line_discount_percentage"
                                                            ></v-text-field>
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-else-if="props.item.line_discount_type == 'A'"
                                                                v-model="props.item.line_discount_amount"
                                                            ></v-text-field>
                                                            <v-btn
                                                                x-small
                                                                raised
                                                                class="ma-0 pa-0"
                                                                style="min-width: 25px !important"
                                                                @click="setDetailDiscount(props.index)"
                                                            >
                                                                {{
                                                                    convert_currency == true
                                                                        ? bill.currency_prefix != null && props.item.line_discount_type == "A"
                                                                            ? bill.currency_prefix
                                                                            : "%"
                                                                        : props.item.line_discount_type == "P"
                                                                        ? "%"
                                                                        : "$"
                                                                }}</v-btn
                                                            >
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="convert_currency == true && bill.currency_prefix != null ? bill.currency_prefix : '$'"
                                                                v-model="props.item.line_total"
                                                                v-readonly-click
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-icon @click="removeRow(props.index)">delete</v-icon>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </div>
                                        <v-card class="mx-auto mb-4" elevation="0">
                                            <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                    <v-flex xs12 sm8>
                                                        <v-container fluid class="pa-0">
                                                            <v-btn v-if="bill.status_id != 90" x-small raised color="primary" @click="addRow()">{{
                                                                $t("lang.add_more")
                                                            }}</v-btn>
                                                        </v-container>
                                                    </v-flex>
                                                    <v-flex xs12 sm4>
                                                        <table style="width: 100%">
                                                            <tbody>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">
                                                                        {{ $t("lang.subtotal") }}
                                                                    </th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && bill.currency_prefix != null
                                                                                    ? bill.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && bill.currency_suffix != null
                                                                                    ? bill.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="bill.subtotal"
                                                                            :counter="showCounter(bill.subtotal, 'bills.subtotal')"
                                                                            :rules="ifValid('bills.subtotal')"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.discount") }}</th>
                                                                    <td>
                                                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                                            <v-flex xs11 class="pr-3" :class="$bp.smallScreen ? 'pl-0' : null">
                                                                                <v-text-field
                                                                                    v-model="bill.discount"
                                                                                    :counter="showCounter(bill.discount, 'bills.discount')"
                                                                                    :rules="ifValid('bills.discount')"
                                                                                ></v-text-field>
                                                                            </v-flex>
                                                                            <v-flex xs1 class="pl-0">
                                                                                <v-container fluid class="pa-0">
                                                                                    <v-btn
                                                                                        class="ma-0 pa-0"
                                                                                        x-small
                                                                                        raised
                                                                                        style="min-width: 25px !important"
                                                                                        @click="setDiscount(bill.discount_type)"
                                                                                        >{{
                                                                                            convert_currency == true
                                                                                                ? bill.currency_prefix != null && bill.discount_type == "A"
                                                                                                    ? bill.currency_prefix
                                                                                                    : "%"
                                                                                                : bill.discount_type == "P"
                                                                                                ? "%"
                                                                                                : "$"
                                                                                        }}</v-btn
                                                                                    >
                                                                                </v-container>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.freight") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && bill.currency_prefix != null
                                                                                    ? bill.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && bill.currency_suffix != null
                                                                                    ? bill.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="bill.freight"
                                                                            :counter="showCounter(bill.freight, 'bills.freight')"
                                                                            :rules="ifValid('bills.freight')"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.customs") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && bill.currency_prefix != null
                                                                                    ? bill.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && bill.currency_suffix != null
                                                                                    ? bill.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="bill.customs"
                                                                            :counter="showCounter(bill.customs, 'bills.customs')"
                                                                            :rules="ifValid('bills.customs')"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.expedite_fee") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && bill.currency_prefix != null
                                                                                    ? bill.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && bill.currency_suffix != null
                                                                                    ? bill.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="bill.expedite_fee"
                                                                            :counter="showCounter(bill.expedite_fee, 'bills.expedite_fee')"
                                                                            :rules="ifValid('bills.expedite_fee')"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.handling_charge") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && bill.currency_prefix != null
                                                                                    ? bill.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && bill.currency_suffix != null
                                                                                    ? bill.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="bill.handling_charge"
                                                                            :counter="showCounter(bill.handling_charge, 'bills.handling_charge')"
                                                                            :rules="ifValid('bills.handling_charge')"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.total_amount") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && bill.currency_prefix != null
                                                                                    ? bill.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && bill.currency_suffix != null
                                                                                    ? bill.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="bill.total_amount"
                                                                            :counter="showCounter(bill.total_amount, 'bills.total_amount')"
                                                                            :rules="ifValid('bills.total_amount')"
                                                                            v-readonly-click
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.balance") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && bill.currency_prefix != null
                                                                                    ? bill.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && bill.currency_suffix != null
                                                                                    ? bill.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="bill.balance"
                                                                            v-readonly-click
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                        <v-flex xs12>
                                            <v-textarea
                                                v-model="bill.comments"
                                                :label="$t('lang.comments')"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('bills.comments')"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <bc-autocomplete
                                                v-model="bill.department_id"
                                                :label="$t('lang.department')"
                                                :items="department_options"
                                                item-value="department_id"
                                                item-text="department_name"
                                                :rules="ifValid('bills.department_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-form>
                                </vue-perfect-scrollbar>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-if="bill.status_id != 90" @mouseup.left="$router.push({ name: 'bills' })" flat>{{ $t("lang.cancel") }}</v-btn>
                                <v-btn v-if="bill.status_id != 90" color="success" @click="saveVendorInvoices">{{ $t("lang.save") }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <bc-dialog :value="bill_payment_dialog">
                <v-card>
                    <v-form ref="form_bill_payment">
                        <v-card-title>
                            <span class="headline">{{ bill_payment.payment_id == null ? $t("lang.add_bill_payment") : $t("lang.edit_bill_payment") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeBillPaymentDialog"
                                :dialog-status="bill_payment_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="bill_payment.payment_date"
                                            :label="$t('lang.payment_date')"
                                            :rules="ifValid('bill_payments.payment_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill_payment.amount"
                                            :prefix="convert_currency == true && bill.currency_prefix != null ? bill.currency_prefix : '$'"
                                            :suffix="convert_currency == true && fe_invoice.currency_suffix != null ? fe_invoice.currency_suffix : ''"
                                            :label="$t('lang.amount')"
                                            :counter="showCounter(bill_payment.amount, 'bill_payments.amount')"
                                            :rules="ifValid('bill_payments.amount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <!-- <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="bill_payment.currency_id"
                                            :label="$t('lang.document_currency')"
                                            :items="currencies"
                                            item-value="currency_id"
                                            item-text="name"
                                            :rules="ifValid('bill_payments.currency_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill_payment.exchange_rate"
                                            :label="$t('lang.exchange_rate')"
                                            :counter="showCounter(bill_payment.exchange_rate, 'bill_payments.exchange_rate')"
                                            :rules="ifValid('bill_payments.exchange_rate')"
                                        ></v-text-field>
                                    </v-flex> -->
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="bill_payment.payment_method_id"
                                            :label="`${$t('lang.payment_method_id')} *`"
                                            :items="payment_methods"
                                            item-value="option_id"
                                            item-text="option"
                                            :rules="ifValid('bill_payments.payment_method_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="bill_payment.payment_status_id"
                                            :label="`${$t('lang.payment_status_id')} *`"
                                            :items="payment_status"
                                            item-value="option_id"
                                            item-text="option"
                                            :rules="ifValid('bill_payments.payment_status_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill_payment.reference_number"
                                            :label="$t('lang.reference_number')"
                                            :counter="showCounter(bill_payment.reference_number, 'bill_payments.reference_number')"
                                            :rules="ifValid('bill_payments.reference_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bill_payment.notes"
                                            :label="$t('lang.notes')"
                                            :counter="showCounter(bill_payment.notes, 'bill_payments.notes')"
                                            :rules="ifValid('bill_payments.notes')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="bill_payment.payment_id" color="error" @mouseup.left="$refs.delete_bill_payments.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeBillPaymentDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn v-if="bill_payment.payment_id == null" color="success" @click="createBillPayment">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>

            <bc-address-selector ref="select_address_dialog" @eventname="updateAddress"></bc-address-selector>
            <delete-confirmation-dialog
                ref="delete_vendor_invoice"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_vendor_invoice')"
                :message="$t('lang.delete_vendor_invoice_confirm')"
                @onConfirm="deleteBills()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_vendor_invoice_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteVendorInvoiceDetails()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_bill_payments"
                :heading="$t('lang.delete_bill_payment')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteBillPayments(bill_payment.payment_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import Vue from "vue";
import axios from "axios";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            headers: [
                { text: this.$t("lang.part_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.part"), sortable: false, width: "30%" },
                { text: this.$t("lang.quantity"), sortable: false, width: "5%" },
                { text: this.$t("lang.sales_unit"), sortable: false, width: "10%" },
                { text: this.$t("lang.unit_price"), sortable: false, width: "8%" },
                {
                    text: this.$t("lang.discount"),
                    sortable: false,
                    width: "8%",
                },
                { text: this.$t("lang.line_total"), sortable: false, width: "10%" },
                { text: "", width: "3%", sortable: false },
            ],
            bill_payment_headers: [
                { text: this.$t("lang.payment_id"), sortable: false, width: "9%" },
                { text: this.$t("lang.bill_id"), sortable: false, width: "9%" },
                { text: this.$t("lang.company"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_date"), sortable: false, width: "9%" },
                { text: this.$t("lang.amount"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_method"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_status"), sortable: false, width: "9%" },
                { text: this.$t("lang.reference_number"), sortable: false, width: "9%" },
            ],
            formData: {},
            bill: {
                expedite_fee: "0.000",
                handling_charge: "0.000",
                discount_type: "A",
                freight: "0.000",
                customs: "0.000",
                subtotal: "0.000",
                discount: "0.000",
                total_amount: "0.000",
                bill_details: [],
                billing_address_id: null,
                shipping_address_id: null,
                bill_address: null,
                ship_address: null,
                address_options: [],
                currency_id: "1",
                exchange_rate: "1.000000",
                currency_prefix: "$",
                currency_precision: 3,
                invoice_date: new Date().toISOString().substr(0, 10),
                department_id: "",
                total_payments: "0.000",
            },
            file_name: "",
            dbGetVendorInvoice: _.debounce(this.getBill, 1500, { maxWait: 1500, leading: true, trailing: false }),
            departments: [],
            convert_currency: false,
            bill_payment_dialog: false,
            bill_payment: {
                bill_id: null,
                payment_id: null,
                company_id: null,
                payment_date: new Date().toISOString().slice(0, 10),
                amount: "0.000",
                currency_id: "1",
                exchange_rate: "1.000",
                payment_method_id: "68",
                payment_status_id: "143",
                reference_number: null,
                notes: null,
            },
            showBillPayments: false,
            loading: true,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchBill", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.bill) {
                        this.bill = this.assignObj2(data.bill, this.rules_bills);
                        this.bill_payment.bill_id = this.bill.bill_id;
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "bills", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchBill", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.bill) {
                        next((vm) => {
                            vm.bill = vm.assignObj2(data.bill, vm.rules_bills);
                            vm.bill_payment.bill_id = vm.bill.bill_id;

                            store.dispatch("fetchSetting", {
                                url: "options?slug=vendor_invoice_status&sort_by=2",
                                method: "get",
                                stateProperty: "vendor_invoice_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "bills", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetOptions");
        this.$store.commit("resetPeople");
        this.$store.commit("resetCustomers");
        this.$store.commit("resetCurrencies");
        this.$store.commit("resetFeParts");
        this.$store.commit("resetPaymentTerms");
        this.$store.commit("resetDepartments");
        this.$store.commit("resetShippingCarriers");
        this.$store.commit("resetProjects");
        next();
    },
    computed: {
        ...mapState({
            rules_bills: (state) => state.bills.rules_bills,
            bills: (state) => state.bills.bills,
            selectedBill: (state) => state.bills.selectedBill,
            fe_part_options_by_vendor: (state) => state.fe_parts.fe_part_options_by_vendor,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
            department_options: (state) => state.departments.department_options,
            vendor_options: (state) => state.vendors.vendor_options,
            freight_terms: (state) => state.options_categories.freight_terms,
            bill_status: (state) => state.options_categories.bill_status,
            sales_units: (state) => state.options_categories.sales_units,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            currencies: (state) => state.currencies.currencies,
            payment_methods: (state) => state.options_categories.payment_methods,
            payment_status: (state) => state.options_categories.payment_status,
            projects: (state) => state.projects.project_options,
        }),
        filter_vendor_options() {
            return this.vendor_options.filter((record) => !record.date_deleted || record.company_id === this.bill.company_id);
        },
        filter_freight_terms() {
            return this.freight_terms.filter((record) => !record.date_deleted || record.option_id === this.bill.freight_term_id);
        },
        filter_shipping_carriers() {
            return this.shipping_carriers.filter((record) => !record.date_deleted || record.company_id === this.bill.shipping_carrier_id);
        },
        filter_currencies() {
            return this.currencies.filter((record) => !record.date_deleted || record.currency_id === this.bill.currency_id);
        },
        filter_fe_part_options_by_vendor: function () {
            return function (item) {
                return this.fe_part_options_by_vendor.filter((record) => !record.date_deleted || record.vendor_map_id === item.map_id);
            };
        },
        filter_sales_units: function () {
            return function (item) {
                return this.sales_units.filter((record) => !record.date_deleted || record.option_id === item.sales_unit);
            };
        },
        filter_payment_terms() {
            return this.payment_terms.filter((record) => !record.date_deleted || record.option_id === this.bill.payment_term_id);
        },
        filter_department_options() {
            return this.department_options.filter((record) => !record.date_deleted || record.option_id === this.bill.department_option_id);
        },
    },
    watch: {
        bill: {
            handler: function (newValue) {
                if (!newValue.bill_details) newValue.bill_details = [];

                let subtotal = 0;
                for (let p of newValue.bill_details) {
                    if (p.line_discount_type == "A") {
                        p.line_total = (p.price * p.quantity - p.line_discount_amount).toFixed(this.bill.currency_precision);
                        subtotal += parseFloat(p.line_total);
                    } else {
                        p.line_total = (p.price * p.quantity - (p.price * p.quantity * p.line_discount_percentage) / 100).toFixed(this.bill.currency_precision);
                        subtotal += parseFloat(p.line_total);
                    }
                }
                newValue.subtotal = subtotal.toFixed(this.bill.currency_precision);
                let total = subtotal;
                let discount = newValue.discount_type == "A" ? total - newValue.discount : total - (total * newValue.discount) / 100;
                total =
                    parseFloat(discount) +
                    parseFloat(newValue.expedite_fee) +
                    parseFloat(newValue.handling_charge) +
                    parseFloat(newValue.freight) +
                    parseFloat(newValue.customs);
                newValue.total_amount = total.toFixed(this.bill.currency_precision);
                newValue.balance = (total - newValue.total_payments).toFixed(this.bill.currency_precision);
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions([
            "fetchBill",
            "saveBill",
            "deleteBill",
            "printBill",
            "fetchFeParts",
            "fetchPaymentTerms",
            "fetchCurrencies",
            "fetchShippingCarriers",
            "fetchDepartments",
            "fetchVendors",
            "fetchOptions",
            "saveBillPayment",
            "deleteBillPayment",
            "fetchProjects",
            "fetchFePart",
            "fetchVendor",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (!this.bill.bill_details) this.bill.bill_details = [];
            this.bill.bill_details.push({
                bill_id: `${this.$route.params.id}`,
                part_id: "",
                sales_unit: "",
                price: "0.000",
                quantity: "1",
                line_discount_amount: "0.000",
                line_discount_percentage: "0.000",
                line_discount_type: "P",
                line_total: "0.000",
            });
        },
        removeRow: function (index) {
            this.bill.bill_details.splice(index, 1);
        },
        changeAddress(type) {
            let address_list = this.bill.address_options ? this.bill.address_options : this.company.entity_addresses || [];
            this.$refs.select_address_dialog.showAddresses(address_list, type);
        },
        updateAddress(item, type) {
            if (type == "bill_address") {
                this.bill.billing_address_id = item.entity_addresses_id;
                this.bill.bill_location_label = item.location_label;
                this.bill.bill_address1 = item.address1;
                this.bill.bill_address2 = item.address2;
                this.bill.bill_city = item.city;
                this.bill.bill_state = item.state;
                this.bill.bill_zip_code = item.zip_code;
                this.bill.bill_zip_code_ext = item.zip_code_ext;
                this.bill.bill_country_iso_3 = item.country_iso_3;
            } else if (type == "ship_address") {
                this.bill.shipping_address_id = item.entity_addresses_id;
                this.bill.ship_location_label = item.location_label;
                this.bill.ship_address1 = item.address1;
                this.bill.ship_address2 = item.address2;
                this.bill.ship_city = item.city;
                this.bill.ship_state = item.state;
                this.bill.ship_zip_code = item.zip_code;
                this.bill.ship_zip_code_ext = item.zip_code_ext;
                this.bill.ship_country_iso_3 = item.country_iso_3;
            }
        },
        getBill(pg_refresh = false) {
            this.startLoader();

            this.fetchBill({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.bill) {
                    this.bill = this.assignObj2(data.bill, this.rules_bills);
                    this.convert_currency = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printBill({
                id: `${this.$route.params.id}`,
                view_as: this.convert_currency,
            }).then((data) => {
                if (typeof data != "undefined" && data.bill) {
                    if (this.dev_mode) {
                        this.file_name = data.bill.file_name;
                    } else {
                        this.$refs.print.printReport(data.bill.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveVendorInvoices() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formVendorInvoice")) {
                    let body = this.prepForm(this.bill, this.rules_bills);

                    this.saveBill({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.bill) {
                            this.$router.push({ name: "bill", params: { id: data.bill.bill_id } });
                            this.convert_currency = false;
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { bill_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveVendorInvoices({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.bill) {
                    this.bill = this.assignObj2(data.bill, this.rules_bills);
                    this.convert_currency = false;
                }
            });
        },
        deleteBills() {
            this.deleteBill({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.delete_vendor_invoice_details.close();
                    this.validationOff();
                    this.$router.push({ name: "bills" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.vendor_options.length == 0 || force == true) this.fetchVendors({ body: { options: 1, with_trashed: this.bill.invoice_id ? "1" : "0" } });
            if (this.currencies.length == 0 || force == true) this.fetchCurrencies({ body: { options: 1, with_trashed: this.bill.invoice_id ? "1" : "0" } });
            if (this.bill.company_id != null || force == true)
                this.fetchFeParts({ body: { options: 1, by_vendor: 1, vendor_id: this.bill.company_id, with_trashed: this.bill.invoice_id ? "1" : "0" } });
            if (this.bill.request_date == null || force == true) this.bill.request_date = new Date().toISOString().slice(0, 10);

            if (this.freight_terms == 0 || force == true)
                this.fetchOptions({ body: { slug: "freight_terms", with_trashed: this.bill.invoice_id ? "1" : "0", options: 1 } });
            if (this.bill_status == 0 || force == true)
                this.fetchOptions({ body: { slug: "bill_status", with_trashed: this.bill.invoice_id ? "1" : "0", options: 1 } });
            if (this.sales_units == 0 || force == true)
                this.fetchOptions({ body: { slug: "sales_units", sort_by: "0", with_trashed: this.bill.invoice_id ? "1" : "0", options: 1 } });
            if (this.department_options.length == 0 || force == true)
                this.fetchDepartments({ body: { options: 1, with_trashed: this.bill.invoice_id ? "1" : "0" } });

            if (!this.bill.department_id) this.bill.department_id = this.currUserField("department_id");

            if (this.payment_terms.length == 0 || force == true)
                this.fetchPaymentTerms({ body: { options: 1, with_trashed: this.bill.invoice_id ? "1" : "0" } });

            if (this.shipping_carriers.length == 0 || force == true)
                this.fetchShippingCarriers({ body: { options: 1, with_trashed: this.bill.invoice_id ? "1" : "0", department_id: "1" } });

            if (force == true) {
                this.fetchBill({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.bill) {
                        this.bill = this.assignObj2(data.bill, this.rules_bills);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            }

            if (this.payment_methods == 0 || force == true) this.fetchOptions({ body: { slug: "payment_methods", sort_by: "0", options: 1 } });
            if (this.payment_status == 0 || force == true) this.fetchOptions({ body: { slug: "payment_status", sort_by: "0", options: 1 } });

            if (this.projects.length == 0 || force == true) this.fetchProjects({ body: { options: 1 } });

            this.loading = false;
            this.finishLoader();
        },
        selectCustomer(company_id) {
            if (company_id == null) {
                return;
            } else {
                this.fetchVendor({ id: company_id }).then((data) => {
                    if (data.vendor) {
                        this.company = data.vendor;
                        this.bill.currency_id = this.company.currency_id ? this.company.currency_id : "1";
                        this.bill.exchange_rate = this.company.exchange_rate ? this.company.exchange_rate : "1.000000";
                        this.bill.payment_term_id = this.company.payment_term_id;

                        this.bill.invoice_date = new Date().toISOString().slice(0, 10);

                        this.bill.address_options = this.company.entity_addresses ? this.company.entity_addresses : [];

                        let ship_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "shipping")[0] : null;
                        this.bill.shipping_address_id = ship_address && ship_address.entity_addresses_id ? ship_address.entity_addresses_id : null;
                        this.bill.ship_location_label = ship_address && ship_address.location_label ? ship_address.location_label : null;
                        this.bill.ship_address1 = ship_address && ship_address.address1 ? ship_address.address1 : null;
                        this.bill.ship_address2 = ship_address && ship_address.address2 ? ship_address.address2 : null;
                        this.bill.ship_city = ship_address && ship_address.city ? ship_address.city : null;
                        this.bill.ship_state = ship_address && ship_address.state ? ship_address.state : null;
                        this.bill.ship_zip_code = ship_address && ship_address.zip_code ? ship_address.zip_code : null;
                        this.bill.ship_zip_code_ext = ship_address && ship_address.zip_code_ext ? ship_address.zip_code_ext : null;
                        this.bill.ship_country_iso_3 = ship_address && ship_address.country_iso_3 ? ship_address.country_iso_3 : null;

                        let bill_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "billing")[0] : null;
                        this.bill.billing_address_id = bill_address && bill_address.entity_addresses_id ? bill_address.entity_addresses_id : null;
                        this.bill.bill_location_label = bill_address && bill_address.location_label ? bill_address.location_label : null;
                        this.bill.bill_address1 = bill_address && bill_address.address1 ? bill_address.address1 : null;
                        this.bill.bill_address2 = bill_address && bill_address.address2 ? bill_address.address2 : null;
                        this.bill.bill_city = bill_address && bill_address.city ? bill_address.city : null;
                        this.bill.bill_state = bill_address && bill_address.state ? bill_address.state : null;
                        this.bill.bill_zip_code = bill_address && bill_address.zip_code ? bill_address.zip_code : null;
                        this.bill.bill_zip_code_ext = bill_address && bill_address.zip_code_ext ? bill_address.zip_code_ext : null;
                        this.bill.bill_country_iso_3 = bill_address && bill_address.country_iso_3 ? bill_address.country_iso_3 : null;

                        if (this.bill.company_id != null)
                            this.fetchFeParts({
                                body: {
                                    options: 1,
                                    by_vendor: 1,
                                    vendor_id: this.bill.company_id,
                                    with_trashed: this.bill.bill_id ? "1" : "0",
                                },
                            });
                    }
                });
            }
        },
        setDetailDiscount(index) {
            let part = this.bill.bill_details[index];
            if (part.line_discount_type == "P") {
                part.line_discount_type = "A";
                part.line_discount_amount = part.line_discount_percentage;
                part.line_discount_percentage = "0.000";
            } else {
                part.line_discount_type = "P";
                part.line_discount_percentage = part.line_discount_amount;
                part.line_discount_amount = "0.000";
            }
        },
        setDiscount() {
            if (this.bill.discount_type == "P" || this.bill.discount_type == "%") {
                this.bill.discount_type = "A";
            } else {
                this.bill.discount_type = "P";
            }
        },
        handleChangePart(index, item) {
            this.validationOff();
            // Get the part from the fe_part_options array based on the part_id
            let partObj = this.fe_part_options_by_vendor.find((x) => x.vendor_map_id == item.map_id);
            this.fetchFePart({ id: partObj.part_id }).then((data) => {
                if (typeof data != "undefined" && data.fe_part) {
                    let partObj = data.fe_part;
                    this.bill.bill_details[index].part_id = partObj.part_id;
                    this.bill.bill_details[index].price = partObj.part_cost;
                    this.bill.bill_details[index].unit_price = partObj.sales_price;
                    this.bill.bill_details[index].model_number = partObj.model_number;
                    this.bill.bill_details[index].sales_unit = partObj.sales_unit;
                    this.bill.bill_details[index].name = partObj.name;
                    this.bill.bill_details[index].lead_time = partObj.lead_time;
                    this.bill.bill_details[index].hts_code = partObj.hts_code;

                    this.$refs[`${index}_quantity`].$el.querySelector("input").focus();
                }
            });
        },

        setExchangeRate(currency_id) {
            let exchange_rate = this.currencies.find((x) => x.currency_id == currency_id);
            this.bill.currency_id = exchange_rate.currency_id;
            this.bill.exchange_rate = exchange_rate.exchange_rate ? exchange_rate.exchange_rate : "1.000000";
        },
        closeBillPaymentDialog() {
            this.bill_payment_dialog = false;
            this.bill_payment = {
                bill_id: this.bill.bill_id,
                payment_id: null,
                company_id: null,
                payment_date: new Date().toISOString().slice(0, 10),
                amount: "0.000",
                currency_id: "1",
                exchange_rate: "1.000",
                payment_method_id: "68",
                payment_status_id: "143",
                reference_number: null,
                notes: null,
            };
            this.$refs.delete_bill_payments.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        createBillPayment() {
            if (parseInt(this.bill.balance) - parseInt(this.bill_payment.amount) < 0) {
                let alert_message = this.$t("lang.payment_larger_than_balance");
                setTimeout(function () {
                    Vue.notify({
                        group: "loggedIn",
                        type: "error",
                        text: alert_message,
                    });
                }, 1000);
            } else {
                this.saveBillPayment({
                    body: this.bill_payment,
                }).then((data) => {
                    if (typeof data != "undefined" && data.bill) {
                        this.bill_payment_dialog = false;
                        this.bill_payment = {
                            bill_id: this.bill.bill_id,
                            payment_id: null,
                            company_id: null,
                            payment_date: new Date().toISOString().slice(0, 10),
                            amount: "0.000",
                            currency_id: "1",
                            exchange_rate: "1.000",
                            payment_method_id: "68",
                            payment_status_id: "143",
                            reference_number: null,
                            notes: null,
                        };
                        this.bill = this.assignObj2(data.bill, this.rules_bills);

                        this.validationOff();
                        this.toggleModalLoader(false);
                    }
                });
            }
        },
        setupBillPaymentDialog(item = null) {
            this.bill_payment_dialog = true;
            if (item != null) {
                this.bill_payment = item;
            } else {
                this.bill_payment.amount = this.bill.balance;
            }
        },
        deleteBillPayments(id = null) {
            this.deleteBillPayment({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.bill = this.assignObj2(data.bill, this.rules_bills);
                    this.closeBillPaymentDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },
    },
};
</script>
<style lang="css" scoped>
.a-top table.v-table tbody tr td {
    vertical-align: top !important;
}

.slide-container {
    transition: height 0.5s;
    overflow: hidden;
}

.slide-up {
    height: 0;
}

.slide-down {
    height: auto;
}

.underline-on-hover .v-card__title label {
    position: relative;
    display: inline-block;
}

.underline-on-hover .v-card__title label::after {
    content: " ";
    background-color: black;
    width: 0;
    position: absolute;
    left: 0;
    bottom: 2px;
    height: 1px;

    -webkit-transition: width 0.5s ease-in-out;
    -moz-transition: width 0.5s ease-in-out;
    -o-transition: width 0.5s ease-in-out;
    transition: width 0.5s ease-in-out;
}

.underline-on-hover:hover .v-card__title label::after {
    width: 100%;
}
</style>
